module.exports = __webpack_public_path__ + "static/fssc-2b11944b4ca8ccca4cae731ed87ecce1.jpg";